module.exports = __webpack_public_path__ + "img/parter.58ffa5a4.png";